import { createSlice } from '@reduxjs/toolkit'

let incrementValue = 5
const parsedIncrementValue = parseInt(process.env.REACT_APP_QUOTE_INCREMENT)

if(!isNaN(parsedIncrementValue)){
    incrementValue = parsedIncrementValue
}

export const productRecommendationsSlice = createSlice({
    name: 'productRecommendations',
    initialState: {
        products: [],
        reccomendations: [],
    },
    reducers: {
        setProducts(state, action){
            state.products = action.payload
        },
        setReccomendations(state, action){
            state.reccomendations = action.payload
        },
        removeReccomendations(state, action) {
            const {removeUIDs} = action.payload // array of vm product uids
            state.reccomendations = state.reccomendations.filter( r => !removeUIDs.includes(r.uid))
        },
        updateReccomendation(state, action) {
            const {reccomendation} = action.payload
            let recIdx = state.reccomendations.findIndex(r => r.uid === reccomendation.uid)

            if(recIdx > -1){
                state.reccomendations[recIdx] = reccomendation
            }
        },

    },
})
export const { setProducts, setReccomendations, removeReccomendations, updateReccomendation } = productRecommendationsSlice.actions;

export default productRecommendationsSlice.reducer;